export default __webpack_public_path__ + "static/media/virgin.00cc9dff.png";